module.exports = __webpack_public_path__ + "static/Template_logobase_2-a5f1f10aab459b6cf3759972f305f8c3.png";